import { cn } from "@/utils/cn";

interface BackIconProps {
  className?: string;
}

export const BackIcon = ({ className }: BackIconProps) => {
  return (
    <svg
      width="44"
      height="44"
      viewBox="0 0 44 44"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cn("stroke-button-black-default", className)}
    >
      <path
        d="M26 14L18 22.5L26 31"
        strokeWidth="2"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
    </svg>
  );
};
